import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import SolarCalculator from "./components/SolarCalculator";
import CTABand from "./components/CTABand";
import Projects from "./components/Projects";
import Industries from "./components/Industries";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import EnquireModal from "./components/EnquireModal";
import FloatingActions from "./components/FloatingActions";
import { Toaster } from "./components/ui/toaster";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import EnquiriesPanel from "./admin/EnquiriesPanel";
import ContentEditor from "./admin/ContentEditor";

import LegalPage from "./pages/LegalPage";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";

import { ContentProvider } from "./contexts/ContentContext";

function Home() {
  const [open, setOpen] = useState(false);
  const openEnquire = () => setOpen(true);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Navbar onEnquire={openEnquire} />
      <Hero onEnquire={openEnquire} />
      <About onEnquire={openEnquire} />
      <Services onEnquire={openEnquire} />
      <WhyChooseUs />
      <SolarCalculator onEnquire={openEnquire} />
      <CTABand onEnquire={openEnquire} />
      <Projects onEnquire={openEnquire} />
      <Industries onEnquire={openEnquire} />
      <Testimonials />
      <FAQ />
      <Footer />
      <FloatingActions onEnquire={openEnquire} />
      <EnquireModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<LegalPage />} key="privacy" />
            <Route path="/terms" element={<LegalPage />} key="terms" />
            <Route path="/refund" element={<LegalPage />} key="refund" />
            <Route path="/page/:pageKey" element={<LegalPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<EnquiriesPanel />} />
              <Route path="content" element={<ContentEditor />} />
            </Route>
          </Routes>
          <Toaster />
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
